import axios from "axios";
import { cfg } from "../runtimeConfig";

export const VERIFICATION_REQUEST_TIMEOUT_MS = 12000;

// Verification sessions authenticate with their short-lived handoff token,
// not the collaborator JWT. Keeping this client interceptor-free prevents an
// expired handoff from clearing an unrelated enterprise login or redirecting a
// mobile representative away from the tokenized page.
export const verificationAPI = axios.create({
  baseURL: cfg.REACT_APP_API_URL,
  // A provider outage must not leave the public onboarding button or status
  // loop locked forever. Start is server-queued, so every browser request is
  // expected to return well inside this client-side deadline.
  timeout: VERIFICATION_REQUEST_TIMEOUT_MS,
});
